import React, {Fragment, memo} from 'react';
import {useSelector} from 'react-redux';

import {viewSelector} from '@mapsight/ui/src/js/store/selectors';
import {VIEW_DESKTOP, VIEW_MOBILE} from '@mapsight/ui/src/js/config/constants/app';

import {useNavPos} from '../../hooks';
import {withErrorBoundary} from '../../modules/error-boundary';
import {memoForever} from '../../modules/helpers';

import PageFooter from '../../stade/components/page-footer';
import DetailsImpressions from '../../stade/components/details-impressions';
import Ratings from '../../ratings/components/ratings';
import NaviWidget from '../../stade/components/navi-widget';
import AudioPlayer from '../../stade/components/audio-player';


/** @type {import("@mapsight/ui/src/js/components/contexts").AppWrapperEnd} */
const AppWrapperEnd = withErrorBoundary(memo(function AppWrapperEnd({}) {
		const view = useSelector(viewSelector);
		const navPos = useNavPos();

		return (
			<Fragment>
				{(view === VIEW_DESKTOP) &&
					<DetailsImpressions />
				}
				{(view === VIEW_DESKTOP && navPos.deepLink && navPos.withStarsRating) &&
					<Ratings />
				}
				{(view === VIEW_MOBILE || view === VIEW_DESKTOP) &&
					<PageFooter />
				}
				{view === VIEW_MOBILE && <Fragment>
					<div className="stade-mobile-float">
						{navPos.deepLink && <AudioPlayer />}
						<NaviWidget />
					</div>
				</Fragment>}
			</Fragment>
		);
	},
	memoForever
));
export default AppWrapperEnd;
